import { useState } from "react";
import { Navigate } from "react-router-dom";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Field } from "@/components/common";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";

export default function Login() {
  const { user, login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to="/" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="grid min-h-screen lg:grid-cols-[1.2fr_1fr]">
      <section className="dt-bg-network relative hidden flex-col justify-between p-12 lg:flex">
        <img src="/logo-sm.png" alt="DTech42" className="h-20 w-20 rounded-xl border border-cyan-400/30" />
        <div className="max-w-md dt-rise">
          <p className="font-mono-dt text-xs uppercase tracking-[0.3em] text-cyan-300">Saint-Marcellin-en-Forez · Loire</p>
          <h1 className="mt-4 text-5xl font-bold leading-tight text-white">Vos interventions, clients et commandes au même endroit.</h1>
          <p className="mt-4 text-slate-300">L'outil de suivi interne de DTech42, informatique de proximité.</p>
        </div>
        <p className="text-xs text-slate-500">© DTech42</p>
      </section>
      <section className="flex items-center justify-center p-6 dt-dots">
        <form onSubmit={submit} className="dt-card w-full max-w-sm space-y-5 p-8 dt-rise" data-testid="login-form">
          <div className="flex items-center gap-3 lg:hidden">
            <img src="/logo-sm.png" alt="DTech42" className="h-12 w-12 rounded-lg" />
            <span className="font-display text-xl font-bold">DTech42</span>
          </div>
          <div>
            <h2 className="text-2xl font-semibold text-white">Connexion</h2>
            <p className="text-sm text-slate-400">Accès réservé à l'équipe DTech42.</p>
          </div>
          <Field label="Email">
            <Input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email-input" autoComplete="username" />
          </Field>
          <Field label="Mot de passe">
            <Input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password-input" autoComplete="current-password" />
          </Field>
          {error && <p className="text-sm text-red-300" data-testid="login-error">{error}</p>}
          <Button type="submit" disabled={loading} className="w-full dt-glow" data-testid="login-submit-button">
            {loading ? "Connexion…" : "Se connecter"}
          </Button>
        </form>
      </section>
    </div>
  );
}
